/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-not-implemented-page',
  templateUrl: 'not-implemented-page.component.html',
})
export class NotImplementedPageComponent {
}
